export const siteUrl = 'https://www.modd.io';
export const worldMapId = '683d442894e55a85502de7bc'; // Tales of Meteora
